import PrefixedLabel from './PrefixedLabel';
import './style/index.less';

export default PrefixedLabel;
